import React from 'react'
import ActivityTabContainer from '../delivery-activity-tab-container'

const Index = () => {
    return(
        <div className="new-list-left-container-tab-content tab-content" id="nav-tabContentLeft">
            <ActivityTabContainer/>
        </div>
    )
}

export default Index